import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { addDefaultSrc, getDefaultSrc } from '../news-helpers';
import { NEWS_IMAGE_PATH } from '../../../../constants/PathsConstant';
import qs from 'qs';
import SafeHtml from '../../../../components/SafeHtml';

export default function ArticleBrief({ newsDetails }) {
  const location = useLocation();
  const baseClass = 'row newsMain fadeInAnimation pdfpagebreakinsideavoid';

  const title = newsDetails.news_headline || newsDetails.headLine || 'No Title';
  const articleContent = newsDetails.news_article
    ? newsDetails.news_article.substring(0, 300)
    : newsDetails.shortArticle || '';
  const date = newsDetails.news_date
    ? new Date(newsDetails.news_date).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : newsDetails.newsDate
      ? new Date(newsDetails.newsDate).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      : '';

  const imageSrc = newsDetails.image_filename
    ? `${NEWS_IMAGE_PATH}${encodeURIComponent(newsDetails.image_filename)}`
    : getDefaultSrc(newsDetails);
  const newsId = newsDetails.news_id || newsDetails.newsid || newsDetails.newsId;
  const currentQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const linkToQuery = { ...currentQuery, newsID: newsId };
  const linkTo = `${location.pathname}?${qs.stringify(linkToQuery)}`;

  return (
    <div key={newsId}>
      <div id={newsId} />
      <div
        className={`${baseClass} ${newsDetails?.rowHighlight ? 'bg-green-highlight' : ''} ${newsDetails.visited ? 'newsVisited' : ''}`}
      >
        <Link to={linkTo} className="col-5 col-md-2 p-0 cursor-pointer m-auto">
          <img
            aria-hidden="true"
            onError={addDefaultSrc}
            src={imageSrc}
            className="rounded mx-auto d-block"
            alt="newslogo"
          />
        </Link>
        <div className="col-7 col-md-10 col-sm-10">
          <div className="row mx-2">
            <div className="col-12 col-md-12">{newsDetails.module && <p>{newsDetails.module}</p>}</div>
            <div className="col-12 col-md-12">
              <Link to={linkTo} activeclassname="active" className="mostReadNewsTitle titleBlock cursor-pointer">
                <SafeHtml html={title} tag="b" />
              </Link>
            </div>
            <div className="col-12 col-md-12">
              <p>{date}</p>
            </div>
            <div className="col-12 col-md-12">
              <i className={newsDetails?.readOnly ? 'readOnly' : ''} />
              <SafeHtml html={articleContent} tag="p" className="d-none d-md-block" />
            </div>
            <div className="col-12 col-md-12 cursor-pointer">
              <p aria-hidden="true">
                <Link to={linkTo} className="mostReadLink">
                  <b>Read more</b>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
